import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions-settings/$')({
  beforeLoad: () => {
    throw redirect({ to: window.location.pathname.split('/')?.toSpliced(3, 1, 'settings/exceptions').join('/'), search: true });
  },
});
